module.exports = __webpack_public_path__ + "static/img/15013A_1_C_20221227_LC.4cdc920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15013A_1_C_20221227_LC.png
// module id = +uTb
// module chunks = 0